import { REPORT_TYPE_IDS } from "./constants";
import { downloadAgentServiceTimeCsvFiles } from "./agentServiceTimeExport";
import { downloadAgentTicketsPerServiceCsvFile } from "./agentTicketsPerServiceExport";
import { downloadArrivalRatesPerServiceCsvFiles } from "./arrivalRatesPerServiceExport";
import { downloadArrivalRatesSummaryCsvFiles } from "./arrivalRatesSummaryExport";
import { downloadCustomersInBranchCsvFiles } from "./customersInBranchExport";
import { downloadServiceTimePerServiceCsvFiles } from "./serviceTimePerServiceExport";
import { downloadTicketSummaryCsvFiles } from "./ticketSummaryExport";
import { downloadTicketsPerAgentCsvFiles } from "./ticketsPerAgentExport";
import { downloadTicketsPerServiceCsvFiles } from "./ticketsPerServiceExport";
import { downloadWaitingTimePerServiceCsvFiles } from "./waitingTimePerServiceExport";
import { downloadWaitingTimeSummaryCsvFiles } from "./waitingTimeSummaryExport";

const asArray = (value) => {
  if (Array.isArray(value)) return value.filter(Boolean);
  return value ? [value] : [];
};

const organizationServiceScopes = (data) => [
  { scope: "Organization", branchName: "", data: asArray(data) },
];

const branchServiceScopes = (data) =>
  asArray(data).map((branch) => ({
    scope: "Branch",
    branchName: branch.branchName || "",
    branchTotalArrivals: branch.branchTotalArrivals,
    data: branch.servicesData || branch.serviceData || [],
  }));

const summaryArgs = ({ data, renderConfig, filenamePrefix }) => ({
  scopes: asArray(data),
  renderConfig,
  filenamePrefix,
});

const scopedArgs = ({ scopes, renderConfig, filenamePrefix }) => ({
  scopes,
  renderConfig,
  filenamePrefix,
});

const DAILY_EXPORTERS = Object.freeze({
  [REPORT_TYPE_IDS.daily_organization_tickets]: ({ data, renderConfig }) =>
    downloadTicketSummaryCsvFiles(summaryArgs({ data, renderConfig, filenamePrefix: "daily_organization_tickets" })),
  [REPORT_TYPE_IDS.daily_organization_tickets_per_branch]: ({ data, renderConfig }) =>
    downloadTicketSummaryCsvFiles(summaryArgs({ data, renderConfig, filenamePrefix: "daily_organization_tickets_per_branch" })),
  [REPORT_TYPE_IDS.daily_organization_waiting_time]: ({ data, renderConfig }) =>
    downloadWaitingTimeSummaryCsvFiles(summaryArgs({ data, renderConfig, filenamePrefix: "daily_organization_waiting_time" })),
  [REPORT_TYPE_IDS.daily_organization_arrival_rates_per_hour]: ({ data, renderConfig }) =>
    downloadArrivalRatesSummaryCsvFiles(summaryArgs({ data, renderConfig, filenamePrefix: "daily_organization_arrival_rates_per_hour" })),
  [REPORT_TYPE_IDS.daily_branch_arrival_rates_per_hour]: ({ data, renderConfig }) =>
    downloadArrivalRatesSummaryCsvFiles(summaryArgs({ data, renderConfig, filenamePrefix: "daily_branch_arrival_rates_per_hour" })),
  [REPORT_TYPE_IDS.daily_branch_customers_in_branch_per_hour]: ({ data, renderConfig }) =>
    downloadCustomersInBranchCsvFiles(summaryArgs({ data, renderConfig, filenamePrefix: "daily_branch_customers_in_branch_per_hour" })),
  [REPORT_TYPE_IDS.daily_organization_tickets_per_service]: ({ data, renderConfig }) =>
    downloadTicketsPerServiceCsvFiles(scopedArgs({
      scopes: organizationServiceScopes(data),
      renderConfig,
      filenamePrefix: "daily_organization_tickets_per_service",
    })),
  [REPORT_TYPE_IDS.daily_branch_tickets_per_service]: ({ data, renderConfig }) =>
    downloadTicketsPerServiceCsvFiles(scopedArgs({
      scopes: branchServiceScopes(data),
      renderConfig,
      filenamePrefix: "daily_branch_tickets_per_service",
    })),
  [REPORT_TYPE_IDS.daily_organization_service_time_per_service]: ({ data, renderConfig }) =>
    downloadServiceTimePerServiceCsvFiles(scopedArgs({
      scopes: organizationServiceScopes(data),
      renderConfig,
      filenamePrefix: "daily_organization_service_time_per_service",
    })),
  [REPORT_TYPE_IDS.daily_branch_service_time_per_service]: ({ data, renderConfig }) =>
    downloadServiceTimePerServiceCsvFiles(scopedArgs({
      scopes: branchServiceScopes(data),
      renderConfig,
      filenamePrefix: "daily_branch_service_time_per_service",
    })),
  [REPORT_TYPE_IDS.daily_organization_waiting_time_per_service]: ({ data, renderConfig }) =>
    downloadWaitingTimePerServiceCsvFiles(scopedArgs({
      scopes: organizationServiceScopes(data),
      renderConfig,
      filenamePrefix: "daily_organization_waiting_time_per_service",
    })),
  [REPORT_TYPE_IDS.daily_branch_waiting_time_per_service]: ({ data, renderConfig }) =>
    downloadWaitingTimePerServiceCsvFiles(scopedArgs({
      scopes: branchServiceScopes(data),
      renderConfig,
      filenamePrefix: "daily_branch_waiting_time_per_service",
    })),
  [REPORT_TYPE_IDS.daily_organization_arrival_rates_per_service]: ({ data, renderConfig }) =>
    downloadArrivalRatesPerServiceCsvFiles(scopedArgs({
      scopes: organizationServiceScopes(data),
      renderConfig,
      filenamePrefix: "daily_organization_arrival_rates_per_service",
    })),
  [REPORT_TYPE_IDS.daily_branch_arrival_rates_per_service]: ({ data, renderConfig }) =>
    downloadArrivalRatesPerServiceCsvFiles(scopedArgs({
      scopes: branchServiceScopes(data),
      renderConfig,
      filenamePrefix: "daily_branch_arrival_rates_per_service",
    })),
  [REPORT_TYPE_IDS.daily_branch_agent_service_time_per_service]: ({ data, renderConfig }) =>
    downloadAgentServiceTimeCsvFiles({ data: asArray(data), renderConfig }),
  [REPORT_TYPE_IDS.daily_branch_agent_tickets_per_service]: ({ data, renderConfig }) =>
    downloadAgentTicketsPerServiceCsvFile({ data: asArray(data), renderConfig }),
  [REPORT_TYPE_IDS.daily_branch_tickets_per_agent]: ({ data, renderConfig }) =>
    downloadTicketsPerAgentCsvFiles({ data: asArray(data), renderConfig }),
});

export const getDailyReportCsvAction = ({ reportTypeId, data, renderConfig }) => {
  const exporter = DAILY_EXPORTERS[reportTypeId];
  if (!exporter || asArray(data).length === 0) return null;
  return () => exporter({ data, renderConfig });
};

